import { createAction } from '@reduxjs/toolkit';

import { RSVP } from 'lib/provider/requests/invitation';

import { Event } from './types';

export const open = createAction('INVITATION/OPEN', (data: Event) => ({
  payload: {
    ...data,
  },
}));

export const close = createAction('INVITATION/CLOSE');

export const setStep = createAction('INVITATION/SET_STEP', (name: 'attending' | 'info' | 'note') => ({
  payload: {
    name,
  },
}));

export const sendAnswerAttending = createAction('INVITATION/SEND_ANSWER_ATTENDING', () => ({
  payload: {
  },
}));

export const sendAnswerNotAttending = createAction('INVITATION/SEND_ANSWER_NOT_ATTENDING', () => ({
  payload: {
  },
}));

export const sendInfo = createAction('INVITATION/SEND_PERSON_INFO', (
  payload:
    | { type: 'AdultChild', numberOfAdultAttendees: number, numberOfChildrenAttendees: number, name?: string, contact?: string }
    | { type: 'Total', numberOfTotalAttendees: number, name?: string, contact?: string },
) => ({
  payload,
}));

export const sendNote = createAction('INVITATION/SEND_NOTE', (note: string, name?: string) => ({
  payload: {
    note,
    name,
  },
}));

export const requestDone = createAction('INVITATION/REQUEST_DONE', (name: 'attending' | 'notAttending' | 'info' | 'note' | string) => ({
  payload: {
    name,
  },
}));

export const setRSVP = createAction('INVITATION/SET_RSVP', (
  rsvp: Partial<Omit<RSVP, 'eventId'>> & { eventId: number },
  mode: 'update' | 'replace' = 'update',
) => {
  const rsvpFinal: Partial<Omit<RSVP, 'eventId'>> & { eventId: number } = {
    ...rsvp,
  };
  Object.keys(rsvp).forEach((key): void => {
    if (typeof rsvpFinal[key as keyof RSVP] === 'undefined') {
      delete rsvpFinal[key as keyof RSVP];
    }
  });
  return {
    payload: {
      rsvp: rsvpFinal,
      mode,
    },
  };
});
